var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"BackTo"},[_c('van-nav-bar',{attrs:{"title":_vm.getTitle,"orderby":_vm.orderby,"left-text":"返回","left-arrow":"","fixed":"","placeholder":"","z-index":"9"},on:{"click-left":_vm.onClickLeft}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }